//@flow
import {
    contract as contractApi,
    contractVersionsApi,
    bulkContractFetch as bulkContractFetchApi,
    disableContract as disableContractApi,
    bulkDisableContract as bulkDisableContractApi,
    validateEntityIds as validateEntityIdsApi
} from 'common/middleware/api';

import PaginatedEntityActions from 'common/redux/actions/PaginatedEntityActions';
import { ApiError } from 'common/modules/api';

import type { Contract as MasterContract } from 'common/models/internal/MasterContract';
import type { Dispatch } from 'redux';

type Params = {
    clientId: string,
    contractId?: string
};

class ContractActions extends PaginatedEntityActions<MasterContract, Params> {
    types = {
        ...this.types,
        ENTITY_VERSIONS_FETCH_START: 'CONTRACT_VERSIONS_FETCH_START',
        ENTITY_VERSIONS_FETCH_SUCCESS: 'CONTRACT_VERSIONS_FETCH_SUCCESS',
        ENTITY_VERSIONS_FETCH_FAILURE: 'CONTRACT_VERSIONS_FETCH_FAILURE'
    };
    entityNameId = 'masterContract';

    entityVersionsFetchStart = params => {
        return {
            type: this.types.ENTITY_VERSIONS_FETCH_START,
            params
        };
    };

    injectEntityVersions = (params, response) => {
        return {
            type: this.types.ENTITY_VERSIONS_FETCH_SUCCESS,
            params,
            response
        };
    };

    entityVersionsFetchError = (params, error) => {
        return {
            type: this.types.ENTITY_VERSIONS_FETCH_FAILURE,
            params,
            error
        };
    };

    fetchEntityVersions = params => {
        return (dispatch: Dispatch<*>) => {
            dispatch(this.entityVersionsFetchStart(params));

            contractVersionsApi
                .fetch(params)
                .then(response => {
                    dispatch(this.injectEntityVersions(params, response));
                })
                .catch(error => {
                    if (error instanceof ApiError) {
                        dispatch(this.entityVersionsFetchError(params, error));
                        return;
                    }
                    throw error;
                });
        };
    };
}

export default new ContractActions(
    'CONTRACT',
    contractApi,
    bulkContractFetchApi,
    disableContractApi,
    bulkDisableContractApi,
    validateEntityIdsApi
);
